export const SUBSCRIPTION_WITHOUT_CONTRACT =
  'Mesečni tarifni paket - bez ugovorne obaveze';
export const SUBSCRIPTION_WITH_CONTRACT =
  'Mesečni tarifni paket - sa ugovornom obavezom';
export const PAY_AS_YOU_GO = 'Plaćanje po oglasu';
export const PROMO_PERIOD = 'Promo period';
export const PROMO_PACKAGE = 'promo-package';
